import React, { useEffect, useState } from "react";
import { ListingCard } from "shared-components/ViewFragments/SearchPage/ListingCard";
import { isSuperHighlighted } from "@Utils/Functions";
import { PropertyCardSkeleton } from "shared-components/Components/Property/PropertyCard/PropertyCardSkeleton";

import dynamic from "next/dynamic"
import { NoResults } from "./NoResults";
import { useFacebookPixel } from "shared-components/GlobalHooks/web/FacebookPixel.hook";
import { ipIsFromCountry } from "shared-components/Components/Banners/BannerArgentoInvest/web";

//@ts-ignore
const BannerSponsorSilver = dynamic(() => import("shared-components/Components/Banners/SponsorSilver/web").then(mod => mod.BannerSponsorSilver), { ssr: false });

export const Listings = ({ data, loading = false, error, forceHideBanners = false }) => {
    const FP = useFacebookPixel();
    let fullData = []

    if (data?.searchFast?.data) {
        fullData = data?.searchFast?.data;
    } else if (data?.landingSeo?.data) {
        fullData = data?.landingSeo?.data;
    }

    const [showSilverBanners, setShowSilverBanners] = useState<boolean>(false)
    const shouldShowSilverBanner = () => Math.round(Math.random() * 100) <= 40
    const argentoSponsorBanner = [
        "https://cdn1.infocasas.com.uy/web/655cb10a8aae9_original_hsbc_premier_campana-no-residentes_infocasas_v1-720x120px_1.gif",
        "https://cdn1.infocasas.com.uy/web/655cb10a8b463_original_hsbc_premier_campana-no-residentes_infocasas_v1-720x120px_2.gif",
        "https://cdn1.infocasas.com.uy/web/655cb10ab7742_original_hsbc_premier_campana-no-residentes_infocasas_v1-720x120px_3.gif"
    ]
    const [isFromAr, setIsFromAr] = useState(false)

    const onClickBannerArgento = e => {
        if (data?.sponsorSilver) {
            FP.StandardEvent("sponsor_silver");
            if (e.ctrlKey || e.metaKey) return false;
        }
    };

    useEffect(() => {
        if (forceHideBanners == false) {
            setShowSilverBanners(shouldShowSilverBanner())
        } else {
            setShowSilverBanners(false)
        }
    }, [data]);

    useEffect(() => {
        ipIsFromCountry("AR")
            .then((res) => setIsFromAr(res))
    }, [])

    const printResults = (res) => {
        let holesPoints = 0
        return res?.map((prop: any, i: number) => {
            const isBigCard = isSuperHighlighted(prop.highlight)
            holesPoints += isBigCard ? 3 : 1
            const couldPrintBanner = holesPoints % 9 == 0 // mod 9 es la cantidad de puntos en 3 filas (3 huecos x 3 filas)
            const randomBanner = Math.floor(Math.random() * argentoSponsorBanner.length);

            return (
                <React.Fragment key={`lc-card-${prop.id}-${i}`}>
                    <ListingCard data={prop} preloadImg={i < 3} />
                    {(couldPrintBanner && i === 2 && isFromAr) ?
                        <a
                            href={"https://api.whatsapp.com/send?phone=+29151010&text=Quisiera información sobre cuenta HSBC Premier en Uruguay."}
                            target="_blank"
                            onClick={onClickBannerArgento}
                            rel="nofollow"
                            className={"sponsor-silver-banner"}
                        >
                            <img src={argentoSponsorBanner[randomBanner]} alt={"HSBC"} />
                        </a> :
                        (couldPrintBanner && i != 0 && i < res?.length - 1 && showSilverBanners) ? <BannerSponsorSilver /> : null
                    }
                </React.Fragment>
            )
        })
    }

    return <>
        {!fullData && fullData.length == 0
            ? <NoResults />
            : <>
                <section className="listingsWrapper">
                    {loading && [...Array(6)].map((_, i) => <div className="listingCard" key={i}><PropertyCardSkeleton /></div>)}
                    {!loading && fullData && printResults(fullData)}
                </section>
            </>
        }
    </>
}